import { defineStore } from "pinia";
import {
  CreateNewCart,
  getCart,
  addItemToCart,
  UpdateItemCart,
  removeItemFromCart,
  clearItemsCart,
  applyPromotionDelegue
} from "@/api/auth";
import { updateOrder } from "@/api/orders";
import { useCheckoutStore } from "./useCheckoutStore";
import { useRegisterStore } from "./register";
import { useDelegueStore } from "./delegueStore";
// import { useProductsStore } from "./productsStore";

export const useCartStore = defineStore("cart", {
  state: () => ({
    cartToken: localStorage.getItem("cartToken") || null,
    cart: {},
    firstcall: true,
    loading: false,
    loadingId: null,
    loadingClear: false,
    productCache: new Map(),
    lastOptimizationTime: 0,
  }),
  getters: {
    CountCart: state =>
      state.cart && state.cart.items?.length ? state.cart.items.reduce((total, item) => total + item.quantity, 0) : 0,
    Cart: state => (state.cart ? state.cart : []),
  },
  actions: {
   async createCart(channel = "WEB") {
  try {

    const registerStore = useRegisterStore();
    const delegueStore = useDelegueStore();
    
    const userRole = registerStore.user?.role || "";
    const isDelegue = userRole === "delegues";
    const vetId = isDelegue ? delegueStore.getSelectedVeterinarian?.id : null;
    const res = await CreateNewCart(channel, isDelegue, vetId);
    this.cartToken = res.data.tokenValue;
    
    
    let payload = {};
    
    if (isDelegue) {
      console.log(res.data, "res.data for delegate");
    payload = {
        billingAddress: res.data.vetCustomer.adressesFacturation,
        shippingAddress: res.data.vetCustomer.adressesFacturation,
      };
    } else {
      // Use regular customer address data
      payload = {
        billingAddress: res.data.customer.adressesFacturation,
        shippingAddress: res.data.customer.adressesFacturation,
      };
    }

    localStorage.setItem("cartToken", this.cartToken);
    this.cart = res.data;

    const checkoutStore = useCheckoutStore();
    console.log("checkoutStore", checkoutStore);
    checkoutStore.setOrder(null);
    console.log(isDelegue, "isDelegue value",vetId);
    await updateOrder(this.cartToken, payload, isDelegue, vetId)
      .then(response => {
        checkoutStore.setOrder(response.data);
      })
      .catch(error => {
        console.error("Erreur updateOrder:", error);
      });
  } catch (error) {
    console.error("Error creating cart", error);
  }
},

   async fetchCart() {
      if (this.firstcall) this.loading = true;

      try {
        // If no token, create a new cart
        if (!this.cartToken) {
          await this.createCart("supplyvet");
        }

        const checkoutStore = useCheckoutStore();
        const res = await getCart(this.cartToken);

        // 🔑 Check if cart state is valid
        if (!res.data || res.data.state !== "cart") {
          console.log("Cart state is not 'cart'. Creating a new one...");
          await this.createCart("supplyvet");
          return; // stop here, cart is recreated
        }
        this.cart = res.data;
        checkoutStore.setOrder(res.data);

        if (this.firstcall) {
          this.firstcall = false;
          this.loading = false;
        }
      } catch (error) {
        console.log("Error fetching cart, creating a new one.", error);
        await this.createCart("supplyvet");
      }
    },


    async addToCart(variantCode, quantity = 1, freeQuantity = 0,isUg = null, ugQuantity = 0) {
      if (!this.cartToken) await this.createCart("supplyvet");

      try {

        const registerStore = useRegisterStore();
        const delegueStore = useDelegueStore();

        const userRole = registerStore.user?.role || "";
        const isDelegue = userRole === "delegues";
        const vetId = isDelegue ? delegueStore.getSelectedVeterinarian?.id : null;
        await addItemToCart(this.cartToken, variantCode, quantity,freeQuantity, isDelegue, vetId, isUg,ugQuantity);
        // Add-item response is a partial payload that drops prior items — refetch instead of assigning it.
        await this.fetchCart();
      } catch (error) {
        console.error("Error adding to cart", error);
      }
    },

    async UpdateCart(ItemId, quantity = 1) {
      this.loadingId = ItemId;
      if (!this.cartToken) {
        await this.createCart("supplyvet");
      }

      try {
        const registerStore = useRegisterStore();
        const delegueStore = useDelegueStore();
        
        const userRole = registerStore.user?.role || "";
        const isDelegue = userRole === "delegues";
        const vetId = isDelegue ? delegueStore.getSelectedVeterinarian?.id : null;
        var response = await UpdateItemCart(this.cartToken, ItemId, quantity, isDelegue, vetId);
        this.cart = response.data;
        this.loadingId = null;
      } catch (error) {
        console.error("Error update cart", error);
      }
    },

    async removeFromCart(itemId) {
      try {
        this.loadingId = itemId;
        await removeItemFromCart(this.cartToken, itemId);

        // Instead of full fetchCart, update cart locally:
        if (this.cart && this.cart.items) {
          this.cart.items = this.cart.items.filter(item => item.id !== itemId);

          // Recalculate prices
          this.cart.itemsSubtotal = this.cart.items.reduce(
            (total, item) => total + item.discountedUnitPrice * item.quantity,
            0
          );
          this.cart.total = this.cart.itemsSubtotal; // adjust if taxes apply
        }

        this.loadingId = null;
      } catch (error) {
        console.error("Error removing item from cart", error);
      }
    },

    async clearCart() {
      try {
        this.loadingClear = true;
        await clearItemsCart(this.cartToken);
        this.cart = null;
        this.cartToken = null;
        localStorage.removeItem("cartToken");
        this.loadingClear = false;
      } catch (error) {
        console.error("Error removing item from cart", error);
      }
    },

    reintializeCart() {
      this.loadingClear = true;
      this.cart = {};
      this.cartToken = null;
      localStorage.removeItem("cartToken");
      this.loadingClear = false;
    },

     getCartItemsCount() {
      return this.CountCart;
    },


    async smartIncrementDecrement(productSlug, targetItem, deltaQuantity) {

      try {
        this.loadingId = targetItem.id;
        const newQty = Math.max(0, (targetItem.quantity || 0) + deltaQuantity);
        if (newQty === 0) {
          await this.removeFromCart(targetItem.id);
        } else {
          await this.UpdateCart(targetItem.id, newQty);
        }
        await this.fetchCart();
      } catch (error) {
        console.error("Erreur incrémentation simple:", error);
        await this.UpdateCart(targetItem.id, Math.max(1, (targetItem.quantity || 1) + deltaQuantity));
      } finally {
        this.loadingId = null;
      }
    },

    async applyPromotion(product, quantity, freeUnitPercentage) {
      if (!this.cartToken) await this.createCart("supplyvet");
      if (!freeUnitPercentage || !this.cartToken) {
        console.log("freeUnitPercentage or cartToken missing", freeUnitPercentage, this.cartToken);
        console.warn('Cannot apply promotion: missing freeUnitPercentage or cartToken');
        return null;
      }

      console.log(product, "product in applyPromotion");

      const porcentage = freeUnitPercentage === 1 ? 'UG 20%' : freeUnitPercentage === 2 ? 'UG 50%' : freeUnitPercentage === 3 ? "UG 100%" : "Unité";
      
      try {
        const promotionPayload = {
          name: porcentage,
          description: `Promotion ${porcentage}% exclusive pour le produit ${product.name}`,
          variant_id: product.id,
          order_token: this.cartToken,
          configuration_quantite_declencheur: quantity,
          configuration_quantite_gagnee_rate: freeUnitPercentage,
          configuration_article_gagne: [product.code]
        };

        var response = await applyPromotionDelegue(promotionPayload);
        return response.data;
      } catch (error) {
        console.error('Error applying promotion:', error);
        throw error; // Re-throw to let the component handle it
      }
    },
  },
});
